// extracted by mini-css-extract-plugin
export default {"container":"CustomButton_container__-YQKs","button":"CustomButton_button__Dh08D"};